import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BREAKPOINTS, BORDER_RADIUS, CARD_SHADOW, SPACING_UNIT, MENU_ITEM_HEIGHT } from './constants';
import { edgeToEdgeMobileContent } from './mixins';
import typography from './typography';
export default {
  MuiAppBar: {
    root: {
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.25)'
    }
  },
  MuiTypography: {
    h4: typography.headline,
    h5: typography.titleBig,
    h6: typography.titleSmall,
    body1: typography.body,
    body2: typography.bodyStrong,
    subtitle2: typography.bodyLight,
    caption: typography.caption,
    overline: typography.overline
  },
  MuiCardHeader: {
    root: {
      paddingLeft: SPACING_UNIT * 3,
      paddingRight: SPACING_UNIT * 3
    }
  },
  MuiPaper: {
    rounded: {
      borderRadius: BORDER_RADIUS
    },
    elevation1: {
      boxShadow: CARD_SHADOW
    },
    elevation2: {
      boxShadow: CARD_SHADOW
    }
  },
  MuiButton: {
    root: {
      textTransform: 'initial'
    },
    contained: {
      backgroundColor: '#fff'
    }
  },
  MuiCard: {
    root: _objectSpread({}, edgeToEdgeMobileContent(), {
      marginBottom: SPACING_UNIT * 2,
      '&:last-of-type': {
        marginBottom: 0
      }
    })
  },
  MuiCardContent: {
    root: _defineProperty({
      padding: SPACING_UNIT * 3,
      paddingTop: SPACING_UNIT * 3,
      paddingBottom: SPACING_UNIT * 3
    }, BREAKPOINTS.down('sm'), {
      padding: SPACING_UNIT * 2,
      paddingTop: SPACING_UNIT * 2,
      paddingBottom: SPACING_UNIT * 2,
      '&:last-of-type': {
        paddingBottom: SPACING_UNIT * 2
      }
    })
  },
  MuiListSubheader: {
    gutters: {
      paddingLeft: SPACING_UNIT * 3,
      paddingRight: SPACING_UNIT * 3
    }
  },
  MuiListItem: {
    gutters: {
      paddingLeft: SPACING_UNIT * 3,
      paddingRight: SPACING_UNIT * 3
    }
  },
  MuiMenuItem: {
    root: _objectSpread({}, typography.body, _defineProperty({}, BREAKPOINTS.up('sm'), {
      minHeight: MENU_ITEM_HEIGHT
    }))
  },
  MuiListItemText: {
    primary: typography.body
  },
  MuiExpansionPanelSummary: {
    content: {
      maxWidth: '100%'
    }
  },
  MuiExpansionPanel: {
    root: {
      '&:first-child': {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      '&:last-child': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  },
  MuiTable: {
    root: {
      borderCollapse: 'initial'
    }
  },
  MuiFormControlLabel: {
    label: typography.body
  },
  MuiTableCell: {
    head: {
      fontSize: typography.caption.fontSize,
      lineHeight: typography.caption.lineHeight,
      color: typography.caption.color
    },
    root: {
      padding: '14px 40px 14px 16px',
      '&:last-child': {
        paddingRight: SPACING_UNIT * 2
      }
    },
    body: {
      fontWeight: typography.body.fontWeight
    }
  },
  MuiTooltip: {
    tooltip: {
      color: '#fff',
      backgroundColor: '#2D3641',
      paddingTop: SPACING_UNIT * 1.5,
      paddingBottom: SPACING_UNIT * 1.5,
      paddingLeft: SPACING_UNIT * 2,
      paddingRight: SPACING_UNIT * 2,
      fontSize: typography.body.fontSize,
      fontWeight: typography.body.fontWeight,
      lineHeight: typography.body.lineHeight
    },
    arrow: {
      color: '#2D3641'
    }
  }
};